import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Button, Container, Row, Col, Form, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'

import WhiteFooter from 'components/Footers/WhiteFooter.js'
import logoMural from 'assets/img/logo_mural_2.png'
import Loading from 'components/Loading/Loading'
import { StudentService } from 'services/student'
import { StudentsHelper } from 'helpers/students'
import ErrorText from '../../components/Texts/ErrorText'
import PanelContext from 'contexts/Panel'
import StudentsTable2 from 'components/Table/StudentsTable2'

const schema = yup.object().shape({
  pesquisa: yup.string().nullable().required('Por favor, informe o nome do aluno'),
})

const ListaAprovadosPage = ({ history }) => {
  const { year, semester, setYear, setSemester, years } = useContext(PanelContext)

  const [isLoading, setIsLoading] = useState(false)
  const [studentsList, setStudentsList] = useState([])
  const [params, setParams] = useState({ pageNumber: 1, pesquisa: null })

  const { errors, setValue, register, handleSubmit } = useForm({ resolver: yupResolver(schema) })

  const goBack = useCallback(() => {
    history.push('/mural-aprovados-sisu')
  }, [history])

  const handleDownloadStudentList = useCallback(async () => {
    await StudentService.downloadStudentsListSheet(year, semester)
  }, [year, semester])

  const getStudentsList = useCallback(async () => {
    setIsLoading(true)
    try {
      const response = await StudentService.studentsList(year, semester, params)
      if (response?.status === 200) {
        const data = StudentsHelper.formatList(response.data)
        setStudentsList(data)
      }
    } catch (e) {
    } finally {
      setIsLoading(false)
    }
  }, [params, year, semester])

  const onSubmit = useCallback(async (value) => {
    setParams({ pageNumber: 1, pesquisa: value.pesquisa })
  }, [])

  const handleCleanInput = useCallback(() => {
    setValue('pesquisa', null)
    setParams({ pesquisa: null })
  }, [setValue])

  useEffect(() => {
    getStudentsList()
  }, [getStudentsList])

  const handleYearChange = ({ target: { value } }) => {
    const [ year, semester ] = value.split('.')
    setYear(parseInt(year))
    setSemester(parseInt(semester))
  }

  const handleDeleteStudent = async (index, { Id }) => {
    setStudentsList(prev => {
      const result = [...prev]
      result.splice(index, 1)
      return result
    })

    StudentService.deleteById(Id)
  }

  return (
    <div className="section">
      <Container className="text-center">
        <Row>
          <Col className="d-flex justify-content-between align-items-center">
            <select
              id="select-year"
              className="form-select"
              aria-label="Selecione o ano"
              onChange={handleYearChange}
              style={{
                color: '#000',
                borderColor: '#aaa',
              }}
            >
              {years.map(item => (
                <option value={item.value} selected={item.value === `${year}.${semester}`}>{item.label}</option>
              ))}
            </select>

            <Button onClick={goBack} className="btn-round" color="#000">
              <span>X</span>
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <img src={logoMural} style={{ width: 260 }} alt="" />
          </Col>
        </Row>
      </Container>

      <Container className="text-center">
        <h2
          className="title"
          style={{
            fontWeight: 600,
            letterSpacing: 2,
            marginTop: 30,
            fontSize: 32,
          }}
        >
          Lista de Aprovados
        </h2>
        <br />
        <p
          className="description"
          style={{
            letterSpacing: 2,
            color: '#000',
            marginTop: -20,
            lineHeight: 1.6,
          }}
        >
          Aqui você encontra a lista de todos os estudantes consultados. Analise seus dados e realize o download do
          conteúdo.
        </p>

        <Form id="cadastro-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="title-brand" style={{ marginTop: 40, letterSpacing: 2, fontSize: 16 }}>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
              <InputGroupText
                  style={{
                    borderRadius: 20,
                    marginRight: 10,
                    height: 45,
                    paddingLeft: 22,
                    paddingRight: 20,
                  }}
                >
                  <i className="nc-icon nc-zoom-split" />
                </InputGroupText>
              </InputGroupAddon>

              <Input
                innerRef={register}
                id="pesquisa"
                name="pesquisa"
                placeholder="Digite aqui sua pesquisa"
                type="text"
                style={{
                  borderRadius: 20,
                  height: 45,
                  paddingLeft: 20,
                  letterSpacing: 3,
                }}
              />
            </InputGroup>
            <ErrorText errors={errors} name="pesquisa" />
          </div>

          <div className="title-brand" style={{ marginTop: 20, letterSpacing: 4, fontSize: 16 }}>
            {isLoading ? (
              <Loading />
            ) : (
              <Row>
                {params.pesquisa && (
                  <Col>
                    <Button
                      type="button"
                      onClick={handleCleanInput}
                      className="btn-round"
                      style={{
                        paddingTop: 10,
                        paddingBottom: 5,
                        fontSize: 14,
                        letterSpacing: 4,
                        textTransform: 'none',
                        color: '#FFF',
                        border: 0,
                        width: '100%',
                        height: 45,
                        borderRadius: 20,
                      }}
                    >
                      <i className="nc-icon nc-zoom-split" style={{ height: 18 }} /> Limpar
                    </Button>
                  </Col>
                )}
                <Col>
                  <Button
                    type="submit"
                    className="btn-round"
                    color="danger"
                    style={{
                      paddingTop: 10,
                      paddingBottom: 5,
                      fontSize: 14,
                      letterSpacing: 4,
                      textTransform: 'none',
                      color: '#FFF',
                      border: 0,
                      width: '100%',
                      height: 45,
                      borderRadius: 20,
                    }}
                  >
                    <i className="nc-icon nc-zoom-split" style={{ height: 18 }} /> Pesquisar
                  </Button>
                </Col>
              </Row>
            )}
          </div>
        </Form>

        <Row
          style={{
            maxWidth: '900px',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            padding: '20px 0',
          }}
        >
          <Col>
            <p className="description" style={{ letterSpacing: 1, color: '#000', lineHeight: 1.6, fontWeight: 600 }}>
              Total de estudantes <span style={{ fontSize: 22 }}>{studentsList?.length || 0}</span>
            </p>
          </Col>
          <Col>
            <Button
              type="button"
              onClick={handleDownloadStudentList}
              className="btn-round"
              color="danger"
              style={{
                padding: '5px 20px',
                fontSize: 14,
                letterSpacing: 4,
                textTransform: 'none',
                color: '#FFF',
                border: 0,
                borderRadius: 20,
              }}
            >
              {' '}
              Download
            </Button>
          </Col>
        </Row>

        <div style={{ marginTop: 30, marginBottom: 30 }}>
          <StudentsTable2
            students={studentsList}
            onDelete={handleDeleteStudent}
          />
        </div>
      </Container>

      <WhiteFooter />
    </div>
  )
}

export default ListaAprovadosPage
